<div class="bg-white rounded-[20px] mb-4 shadow-elevation-1 hover:shadow-elevation-2 transition-shadow">
    <!-- Header: Author info -->
    <div
        class="cursor-pointer px-4 pt-4 pb-2 rounded-t-[20px] hover:bg-[#F7F7F7]"
        [routerLink]="['/post', postSignal().id]">
        <div class="flex gap-2">
            <!-- Pinned Post -->
            @if (isPinned) {
                <div
                    class="w-fit flex space-x-2 text-[0.875rem] bg-[#4F66FF1A] text-[#4F66FF] items-center rounded-full py-1 px-2 mb-3 capitalize">
                    <img alt="Pin" class="h-3 w-3" src="/assets/images/shared/pin-blue-icon.svg" />
                    <p>Pinned Post</p>
                </div>
            }
            <!-- Group Name -->
            @if (postSignal().privacy === PrivacyTypeEnum.Group && postSignal().group) {
                <div
                    class="w-fit flex space-x-2 text-[0.875rem] bg-[#4F66FF1A] text-[#334155] items-center rounded-full py-1 px-2 mb-3 capitalize">
                    <img alt="Group" class="h-3 w-3" src="/assets/images/post/friends-icon.svg" />
                    <p>
                        {{ postSignal().group.name }}
                    </p>
                </div>
            }
            <!-- Announcement -->
            @if (postSignal().type === PostTypeEnum.Announcement) {
                <div
                    class="w-fit flex text-[0.875rem] bg-[#4F66FF1A] text-[#334155] items-center rounded-full py-1 px-2 mb-3 capitalize">
                    <p>
                        {{ getPostTypeLabel(postSignal().type) }}
                    </p>
                </div>
            }
            <!-- Answered -->
            @if (postSignal().answered) {
                <div
                    class="w-fit flex text-[0.875rem] bg-[#ECFDF5] text-[#059669] items-center rounded-full py-1 px-2 mb-3 capitalize">
                    <p>Answered</p>
                </div>
            }
        </div>

        <div class="flex justify-between items-start">
            <div class="flex items-center space-x-4">
                @if (postSignal().privacy === PrivacyTypeEnum.Anonymous && postSignal().anonymousName) {
                    <div
                        class="h-12 w-12 rounded-full bg-[#475569] text-white flex items-center justify-center font-bold text-[1.2rem]">
                        {{ getInitials(postSignal().anonymousName) }}
                    </div>
                } @else {
                    @if (postSignal().author.photo !== ' ' && postSignal().author.photo) {
                        <img
                            class="h-12 w-12 rounded-full object-cover border border-[#e7eaf0]"
                            [alt]="postSignal().author.name"
                            [src]="postSignal().author.photo"
                            [routerLink]="isOwnPost() ? ['/profile'] : ['/profile', postSignal().author.id]"
                            (click)="$event.stopPropagation()" />
                    } @else {
                        <div
                            class="h-12 w-12 rounded-full border border-[#e7eaf0] bg-white text-[#4F66FF] flex items-center justify-center font-bold text-[1.2rem]"
                            [routerLink]="isOwnPost() ? ['/profile'] : ['/profile', postSignal().author.id]"
                            (click)="$event.stopPropagation()">
                            {{ postSignal().author.name.charAt(0) | uppercase }}
                        </div>
                    }
                }
                <div class="flex flex-col">
                    <div class="flex items-center space-x-2">
                        <p
                            class="text-[#0A0A0A] font-semibold cursor-pointer"
                            [routerLink]="isOwnPost() ? ['/profile'] : ['/profile', postSignal().author.id]"
                            (click)="$event.stopPropagation()">
                            {{
                                postSignal().privacy === PrivacyTypeEnum.Anonymous
                                    ? postSignal().anonymousName
                                    : postSignal().author.name
                            }}
                        </p>
                        @if (postSignal().author.verified) {
                            <img src="/assets/images/shared/verified-icon.svg" alt="verified-icon" class="size-4" />
                        }
                    </div>
                    <div class="flex items-center space-x-2">
                        <p class="text-[0.875rem] text-[#717182]">{{ timeAgo(postSignal().createdAt) }}</p>
                        @if (
                            [PrivacyTypeEnum.Public, PrivacyTypeEnum.Anonymous, PrivacyTypeEnum.Follower].includes(
                                postSignal().privacy
                            )
                        ) {
                            <span class="mx-1 text-[#717182]">·</span>
                            <img
                                alt="Privacy"
                                class="h-3 w-3"
                                [src]="
                                    postSignal().privacy === PrivacyTypeEnum.Public
                                        ? '/assets/images/post/public-icon.svg'
                                        : postSignal().privacy === PrivacyTypeEnum.Anonymous
                                          ? '/assets/images/post/anonymous-icon.svg'
                                          : '/assets/images/post/friends-icon.svg'
                                " />
                        }
                    </div>
                </div>
            </div>

            @if (isShowActions) {
                <div class="relative">
                    <div
                        class="sm:block hidden h-4 w-4 cursor-pointer"
                        [matMenuTriggerFor]="dropdownMenu"
                        (click)="$event.stopPropagation()">
                        <img src="/assets/images/shared/more-options-grey-icon.svg" alt="MoreOptions" />
                    </div>

                    <mat-menu #dropdownMenu="matMenu">
                        @for (action of menuActions(); track action.id) {
                            <div
                                class="flex items-center space-x-2 px-4 py-3 cursor-pointer"
                                [routerLink]="action.routerLink"
                                (click)="!action.routerLink && executeMenuAction(action.id)">
                                <img class="w-auto h-4" [alt]="action.label" [src]="action.icon" />
                                <p
                                    class="text-[0.875rem]"
                                    [ngClass]="action.textColor ? `text-[${action.textColor}]` : 'text-[#0A0A0A]'">
                                    {{ action.label }}
                                </p>
                            </div>
                        }
                    </mat-menu>
                </div>
            }
        </div>
    </div>

    <div class="flex flex-col pt-2 pb-6 px-4 gap-2">
        <!-- Post Type  -->
        @if (postSignal().privacy !== PrivacyTypeEnum.Group) {
            <div
                class="w-fit flex space-x-1 text-[0.875rem] rounded-full py-1 px-2 capitalize"
                [ngClass]="
                    postSignal().type === PostTypeEnum.Prayer
                        ? 'bg-[#4F66FF0D] text-[#4F66FF]'
                        : postSignal().type === PostTypeEnum.Testimony
                          ? 'bg-[#ECFDF5] text-[#059669]'
                          : postSignal().type === PostTypeEnum.Post
                            ? 'bg-[#FFF1F2] text-[#E11D48]'
                            : 'bg-white border'
                ">
                @if ([PostTypeEnum.Prayer, PostTypeEnum.Testimony, PostTypeEnum.Post].includes(postSignal().type)) {
                    <img
                        class="h-4 w-auto"
                        alt="PostType"
                        [src]="
                            postSignal().type === PostTypeEnum.Prayer
                                ? '/assets/images/post/prayer-icon.svg'
                                : postSignal().type === PostTypeEnum.Testimony
                                  ? '/assets/images/post/testimony-icon.svg'
                                  : '/assets/images/post/encouragement-icon.svg'
                        " />
                }
                <p>
                    {{ getPostTypeLabel(postSignal().type) }}
                </p>
            </div>
        }

        <!-- Hashtags -->
        <div class="flex flex-wrap gap-2">
            @for (tag of postSignal().cats; track tag) {
                <div class="w-fit truncate whitespace-nowrap text-[0.875rem] text-[#4F66FF] capitalize">
                    <p>#{{ tag }}</p>
                </div>
            }
        </div>

        <!-- Content -->
        <div
            class="text-[#1e293b] text-sm sm:text-[15px] leading-relaxed break-words"
            [innerHTML]="coloredContent"></div>

        <!-- Bible Verses -->
        @if (postSignal().verses && postSignal().verses.length) {
            <div class="py-1 px-4 border-l-4 border-[#4F66FF]">
                <p class="text-[#4F66FF] font-medium text-[0.75rem] mb-2">
                    {{ getVerseReference(postSignal().verses) }}
                </p>
                @for (verse of postSignal().verses; track verse.id) {
                    <p class="text-[#717182] text-sm">
                        {{ verse.verse }}
                    </p>
                }
            </div>
        }
        <!-- Thumbnail Previews -->
        @if (postSignal().url && urlPreview() && urlPreview()!.images) {
            @let preview = urlPreview()!;
            <a target="_blank" class="bg-white block border rounded-lg overflow-hidden shadow-lg" [href]="preview.url">
                <img alt="Thumbnail" class="w-full h-auto object-cover" [src]="preview.images[0]" />

                <div class="p-2">
                    <div class="flex items-center gap-2">
                        @if (preview.favicons.length) {
                            <img alt="Icon" class="w-6 h-6 object-cover" [src]="preview.favicons[0]" />
                        }
                        <p class="text-[0.7rem] text-[#475569]">{{ preview.siteName }}</p>
                    </div>
                    <p class="text-[0.85rem] font-bold text-[#0F172A]">{{ preview.title }}</p>
                    <p class="text-[0.7rem] text-[#475569] line-clamp-3">{{ preview.description }}</p>
                </div>
            </a>
        }

        <!-- Image -->
        @if (postSignal().photo) {
            <img alt="Image" class="rounded-lg block max-w-full h-auto" [src]="postSignal().photo" />
        }

        <!-- Quote -->
        @if (postSignal().originator) {
            <div class="p-6 rounded-2xl space-y-2 bg-[#e0efff]">
                <!-- Author Info -->
                <div class="flex space-x-4">
                    @if (postSignal().originator.author.photo !== ' ' && postSignal().originator.author.photo) {
                        <img
                            class="h-12 w-12 rounded-full object-cover border border-[#e7eaf0]"
                            [alt]="postSignal().originator.author.name"
                            [src]="postSignal().originator.author.photo"
                            [routerLink]="
                                isOwnQuotePost() ? ['/profile'] : ['/profile', postSignal().originator.author.id]
                            "
                            (click)="$event.stopPropagation()" />
                    } @else {
                        <div
                            class="h-12 w-12 rounded-full border border-[#e7eaf0] bg-white text-[#4F66FF] flex items-center justify-center font-bold text-[1.2rem]"
                            [routerLink]="
                                isOwnQuotePost() ? ['/profile'] : ['/profile', postSignal().originator.author.id]
                            "
                            (click)="$event.stopPropagation()">
                            {{ postSignal().originator.author.name.charAt(0) | uppercase }}
                        </div>
                    }
                    <div class="flex flex-col">
                        <p
                            class="text-[#0A0A0A] cursor-pointer"
                            [routerLink]="
                                isOwnQuotePost() ? ['/profile'] : ['/profile', postSignal().originator.author.id]
                            "
                            (click)="$event.stopPropagation()">
                            {{
                                postSignal().originator.privacy === PrivacyTypeEnum.Anonymous
                                    ? postSignal().originator.anonymousName
                                    : postSignal().originator.author.name
                            }}
                        </p>
                        <div class="flex items-center space-x-2">
                            <p class="text-[0.875rem] text-[#717182]">
                                {{ timeAgo(postSignal().originator.createdAt) }}
                            </p>
                            <img
                                alt="Privacy"
                                class="h-3 w-3"
                                [src]="
                                    postSignal().originator.privacy === 'public'
                                        ? '/assets/images/post/public-icon.svg'
                                        : postSignal().originator.privacy === 'anonymous'
                                          ? '/assets/images/post/anonymous-icon.svg'
                                          : '/assets/images/post/friends-icon.svg'
                                " />
                        </div>
                    </div>
                </div>

                <!-- Post Type  -->
                <div
                    class="w-fit flex space-x-1 text-[0.875rem] rounded-full py-1 px-2 capitalize"
                    [ngClass]="
                        postSignal().originator.type === PostTypeEnum.Prayer
                            ? 'bg-[#4F66FF0D] text-[#4F66FF]'
                            : postSignal().originator.type === PostTypeEnum.Testimony
                              ? 'bg-[#ECFDF5] text-[#059669]'
                              : postSignal().originator.type === PostTypeEnum.Post
                                ? 'bg-[#FFF1F2] text-[#E11D48]'
                                : 'bg-white border'
                    ">
                    @if (
                        postSignal().originator.type === PostTypeEnum.Prayer ||
                        postSignal().originator.type === PostTypeEnum.Testimony ||
                        postSignal().originator.type === PostTypeEnum.Post
                    ) {
                        <img
                            class="h-4 w-auto"
                            alt="PostType"
                            [src]="
                                postSignal().originator.type === PostTypeEnum.Prayer
                                    ? '/assets/images/post/prayer-icon.svg'
                                    : postSignal().originator.type === PostTypeEnum.Testimony
                                      ? '/assets/images/post/testimony-icon.svg'
                                      : '/assets/images/post/encouragement-icon.svg'
                            " />
                    }
                    <p>
                        {{ getPostTypeLabel(postSignal().originator.type) }}
                    </p>
                </div>

                <!-- Hashtags -->
                <div class="flex flex-wrap gap-2">
                    @for (tag of postSignal().originator.cats; track tag) {
                        <div class="w-fit truncate whitespace-nowrap text-[0.875rem] text-[#4F66FF] capitalize">
                            <p>#{{ tag }}</p>
                        </div>
                    }
                </div>

                <!-- Content -->
                <div class="mt-4 text-[#1e293b] break-words" [innerHTML]="coloredQuoteContent"></div>

                <!-- Bible Verses -->
                @if (postSignal().originator.verses && postSignal().originator.verses.length) {
                    <div class="py-1 px-4 border-l-4 border-[#4F66FF]">
                        <p class="text-[#4F66FF] font-medium text-[0.75rem] mb-2">
                            {{ getVerseReference(postSignal().originator.verses) }}
                        </p>
                        @for (verse of postSignal().originator.verses; track verse.id) {
                            <p class="text-[#717182] text-sm">
                                {{ verse.verse }}
                            </p>
                        }
                    </div>
                }
                <!-- Thumbnail Previews -->
                @if (postSignal().originator.url && quoteUrlPreview() && quoteUrlPreview()!.images.length) {
                    @let preview = quoteUrlPreview()!;
                    <a
                        target="_blank"
                        class="bg-white block border rounded-lg overflow-hidden shadow-lg"
                        [href]="preview.url">
                        <img alt="Thumbnail" class="w-full h-auto object-cover" [src]="preview.images[0]" />

                        <div class="p-2">
                            <div class="flex items-center gap-2">
                                @if (preview.favicons.length) {
                                    <img alt="Icon" class="w-6 h-6 object-cover" [src]="preview.favicons[0]" />
                                }
                                <p class="text-[0.7rem] text-[#475569]">{{ preview.siteName }}</p>
                            </div>
                            <p class="text-[0.85rem] font-bold text-[#0F172A]">{{ preview.title }}</p>
                            <p class="text-[0.7rem] text-[#475569] line-clamp-3">{{ preview.description }}</p>
                        </div>
                    </a>
                }

                <!-- Image -->
                @if (postSignal().originator.photo) {
                    <img alt="Image" class="rounded-lg block max-w-full h-auto" [src]="postSignal().originator.photo" />
                }
            </div>
        }
    </div>

    <div class="border-t border-[#E7EAF0]"></div>

    <div class="flex flex-col px-4 py-6 gap-2">
        @if (isShowActions) {
            <!-- Actions / Counts -->
            <div class="flex justify-between items-start">
                <div class="flex space-x-10 text-[#717182] text-[0.875rem]">
                    <div class="flex items-center gap-2 cursor-pointer" (click)="toggleLike(postSignal())">
                        <img
                            alt="Like"
                            class="size-5"
                            [src]="
                                postSignal().liked
                                    ? '/assets/images/post/like-red-icon.svg'
                                    : '/assets/images/post/like-grey-icon.svg'
                            " />
                        <span class="min-w-4">{{ postSignal().likeCount }}</span>
                    </div>
                    <div class="flex items-center gap-2 cursor-pointer" [routerLink]="['/post', postSignal().id]">
                        <img src="/assets/images/post/comment-grey-icon.svg" alt="Comment" class="size-5" />
                        <span>{{ postSignal().replyCount }}</span>
                    </div>
                    <div class="flex items-center gap-2 cursor-pointer" (click)="openBadgePopup()">
                        <img src="/assets/images/post/badge-icon.svg" alt="Badge" class="size-5" />
                        <span>{{ postSignal().badgeCount }}</span>
                    </div>
                </div>

                <div class="relative">
                    <div
                        class="sm:hidden h-4 w-4 cursor-pointer"
                        [matMenuTriggerFor]="dropdownMenu"
                        (click)="$event.stopPropagation()">
                        <img src="/assets/images/shared/more-options-grey-icon.svg" alt="MoreOptions" />
                    </div>

                    <mat-menu #dropdownMenu="matMenu">
                        @for (action of menuActions(); track action.id) {
                            <div
                                class="flex items-center space-x-2 px-4 py-3 cursor-pointer"
                                [routerLink]="action.routerLink"
                                (click)="!action.routerLink && executeMenuAction(action.id)">
                                <img class="w-auto h-4" [alt]="action.label" [src]="action.icon" />
                                <p
                                    class="text-[0.875rem]"
                                    [ngClass]="action.textColor ? `text-[${action.textColor}]` : 'text-[#0A0A0A]'">
                                    {{ action.label }}
                                </p>
                            </div>
                        }
                    </mat-menu>
                </div>
            </div>
        }
    </div>

    <div class="flex flex-col gap-2">
        <!-- Testimony & Comment -->
        @if (isShowComment) {
            <div class="flex flex-col gap-3 border-t border-[#E7EAF0] p-4 bg-[#F8FAFC7F]">
                @if (postSignal().answered && postSignal().testimony) {
                    <app-post-comment
                        [isTestimony]="true"
                        [postComment]="postSignal().testimony"
                        [postId]="postSignal().id"
                        (editCommentEvent)="onEditComment($event)" />
                }

                @for (comment of postCommentSignal(); track comment.id) {
                    <app-post-comment
                        [postComment]="comment"
                        [postId]="postSignal().id"
                        (editCommentEvent)="onEditComment($event)" />
                }
                <form id="comment-form" class="space-y-4" [formGroup]="commentForm" (ngSubmit)="submitComment()">
                    <div class="flex items-center gap-4">
                        <input
                            type="text"
                            placeholder="Write a comment..."
                            class="w-full px-3 py-2 border border-[#E7EAF0] rounded-2xl text-sm focus:outline-none"
                            formControlName="content" />

                        <!-- Upload Image -->
                        <input
                            #fileInput
                            type="file"
                            accept="image/*"
                            class="hidden"
                            (change)="onFileSelected($event)" />
                        <button type="button" class="flex-shrink-0" (click)="fileInput.click()">
                            <img src="/assets/images/shared/upload-image-icon.svg" alt="UploadImage" class="size-5" />
                        </button>

                        <!-- Bible Verse -->
                        <button type="button" class="flex-shrink-0" (click)="openBibleVersePopup()">
                            <img src="/assets/images/shared/bible-icon.svg" alt="Bible" class="size-4" />
                        </button>

                        <!-- Submit -->
                        <button
                            type="submit"
                            class="border-button p-2 rounded-lg flex-shrink-0 inline-flex"
                            [disabled]="commentForm.invalid">
                            <img src="/assets/images/shared/up-arrow-icon.png" alt="Up" class="size-4 rotate-90" />
                        </button>
                    </div>

                    <!-- Attachments -->
                    @if (commentImageUrl || selectedBibleVerses().length) {
                        <p class="text-[0.875rem] text-[#0A0A0A] font-medium">Attachments</p>
                    }

                    @if (selectedBibleVerses().length) {
                        <!-- Preview Selected Verses -->
                        @if (selectedBibleVerses().length > 0) {
                            <div class="pb-4 px-4">
                                <div class="relative px-4 border-l-4 border-[#4F66FF]">
                                    <p class="text-[#4F66FF] font-medium text-[0.75rem] mb-2">
                                        {{ getSelectedVerseReference() }}
                                    </p>
                                    <button
                                        type="button"
                                        class="absolute top-1 right-1 w-5 h-5 flex items-center justify-center bg-black rounded-full"
                                        (click)="removeBibleVerse()">
                                        <img
                                            src="/assets/images/shared/x-white-icon.svg"
                                            alt="Close"
                                            class="h-4 w-auto" />
                                    </button>
                                    @for (verse of selectedBibleVerses(); track verse.id) {
                                        <p class="text-[#717182] text-sm">
                                            {{ verse.verse }}
                                        </p>
                                    }
                                </div>
                            </div>
                        }
                    }
                    @if (commentImageUrl) {
                        <div class="relative mt-4 inline-block">
                            <img
                                alt="Preview"
                                class="rounded-lg block max-w-full max-h-[320px] h-auto"
                                [src]="commentImageUrl" />
                            <button
                                type="button"
                                class="absolute top-1 right-1 w-5 h-5 flex items-center justify-center bg-black rounded-full"
                                (click)="removeCommentImage()">
                                <img src="/assets/images/shared/x-white-icon.svg" alt="Close" class="h-4 w-auto" />
                            </button>
                        </div>
                    }
                </form>
            </div>
        }
    </div>
</div>
